import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSavedSizeDeleted.meta';

export type UseTrackSavedSizeDeletedParams = {
  source: 'context';
};

export const useTrackSavedSizeDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackSavedSizeDeleted = useCallback(
    (params: UseTrackSavedSizeDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSavedSizeDeleted };
};
